// extracted by mini-css-extract-plugin
module.exports = {"container":"alert-box__container___1YxK7","backdrop":"alert-box__backdrop___3grUA","input-container":"alert-box__input-container___33Qua"};